import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface INavProps extends TestingProps {
  children?: React.ReactNode;
  variant?: string;
  tabs?: boolean;
  pills?: boolean;
  card?: boolean;
  fixed?: 'left' | 'right' | 'top' | 'bottom';
  top?: boolean;
  role?: string;
  expand?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  widthAuto?: boolean;
  relative?: boolean;
  className?: string;
  vertical?: boolean;
  style?: React.CSSProperties;
  id?: string;
}

const expandMapper: { [index: string]: string } = {
  xs: 'navbar-expand-xs',
  sm: 'navbar-expand-sm',
  md: 'navbar-expand-md',
  lg: 'navbar-expand-lg',
  xl: 'navbar-expand-xl',
};

const variantMapper: { [index: string]: string } = {
  light: 'navbar-light',
  dark: 'navbar-dark',
};

export const Nav: React.FunctionComponent<INavProps> = (props) => {
  return (
    <nav
      id={props.id}
      className={C(
        'navbar',
        props.className,
        props.variant ? variantMapper[props.variant] : 'navbar-light',
        props.tabs && 'nav-tabs',
        props.pills && 'nav-pills',
        props.vertical && 'navbar-vertical',
        props.fixed === 'right'
          ? 'fixed-right'
          : props.fixed === 'left'
          ? 'fixed-left'
          : props.fixed === 'top'
          ? 'fixed-top'
          : props.fixed === 'bottom'
          ? 'fixed-bottom'
          : '',
        props.relative && 'position-relative',
        props.expand ? expandMapper[props.expand] : 'navbar-expand-md',
        props.widthAuto && 'w-auto'
      )}
      data-testid={props.testId}
      style={props.style}
    >
      {props.vertical ? (
        <div className="nav-padding py-6">{props.children}</div>
      ) : (
        <>{props.children}</>
      )}
    </nav>
  );
};
